import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

import ProfileSettingsForm from './profile-settings-form';
import { useState } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { useAuthDialog } from '@/context/auth-dialog.context';

export function ChangePasswordDialog() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const { logout } = useAuth();
  const { openDialog: openAuthDialog } = useAuthDialog();

  const handlePasswordChangeSuccess = () => {
    logout.mutate();
    openAuthDialog();
  };

  return (
    <Dialog open={settingsOpen} onOpenChange={setSettingsOpen}>
      <DialogTrigger asChild>
        <Button>Изменить пароль</Button>
      </DialogTrigger>
      <DialogContent className="user-layout" aria-describedby="">
        <DialogHeader>
          <DialogTitle>Настройки профиля</DialogTitle>
        </DialogHeader>
        <ProfileSettingsForm onSuccessAction={handlePasswordChangeSuccess} />
      </DialogContent>
    </Dialog>
  );
}
